<template>
    <div id="account">
        <div id="content_page" :class="isMobile ? 'active' : ''">
            <account-content />
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import AccountContent from '../components/account/accountContent';

    export default {
        name: 'Account',
        components: { AccountContent },
        computed: {
            ...mapGetters('app', ['isMobile'])
        }
    };
</script>

<style scoped>
    #content_page {
        padding: 20px;
    }

    #content_page.active {
        padding: 0px;
    }
</style>
